export default "__VITE_ASSET__dx8dd6hU__"